import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { RedirectService } from '../services/redirect-service';

export const PermissionGuard: CanActivateChildFn = (
  route: ActivatedRouteSnapshot
) => {
  const redirectService = inject(RedirectService);
  const router = inject(Router);
  const requiredPermissions = (route.data as { permissions?: string[] })
    ?.permissions;

  if (requiredPermissions) {
    // Checking  user has any of the required permissions
    if (
      !requiredPermissions.some(permission =>
        redirectService.hasPermission(permission)
      )
    ) {
      router.navigateByUrl('/access-denied');
    }
  }

  return true;
};
